import { render } from "./view_promotion.vue?vue&type=template&id=7c313101"
import script from "./view_promotion.vue?vue&type=script&lang=js"
export * from "./view_promotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__